import React from "react";
import { Link, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { ESRQuestionConfig } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";
import { Box, IconButton, InputAdornment, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


export const ESRTextField = (props: ESRQuestionConfig & {expiry?: boolean; copy?: boolean;}) => {
	const { question_id, required, hint_value, field_options, locked, inline, staticValue, show_initial_response, field_type, question_help, expiry, copy} =
		props;
	const { esrId = "", activeLabel = "", activeId = "" } = useParams();
	const [value, setValue, setLocalValue] = (staticValue != null) ?
		[staticValue, ()=>{}, ()=>{}] : useRemoteField(question_id, field_options.length > 0 ? field_options[0] : "");
	
const renderWithLinks = (text: string) => {
    if (!text) return null;
    const normalized = text.replace(/\\n/g, "\n");
    const parts = normalized.split(/(<QID:[^>]+>)/g);
    return parts.map((part, index) => {
        const match = part.match(/^<QID:([^>]+)>$/);

        if (match) {
            const qid = match[1];

            return (
                <Link
				key={index}
                    to={`/esr/${esrId}/${activeLabel}/${activeId}/redirect/${qid}`}
                    style={{
                        color: "#1976d2",
                        textDecoration: "underline",
                        fontWeight: 500,
                    }}
                >
                    (Go to QID:{qid})
                </Link>
            );
        }

        return <span key={index}>{part}</span>;
    });
};

const handleCopy = async () => {
    if (!value) return;

    try {
        await navigator.clipboard.writeText(value);
    } catch (err) {
        console.error("Failed to copy text", err);
    }
};

if (expiry) {
        return (
            <Typography
                sx={{
                    color: "#d83654",
                    fontWeight: 500,
                    padding: inline ? "4px 0" : "12px",
                    border: inline ? "none" : "1px solid #0000001F",
                    borderRadius: "4px",
					whiteSpace: "pre-line",
                }}
            >
                {renderWithLinks(value || "")}
            </Typography>
        );
    }
    
if (copy) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                minHeight: 56,
                // padding: inline ? "4px 0" : "12px",
                border: inline ? "none" : "1px solid #0000001F",
                borderRadius: "4px",
            }}
        >
            <Typography
                sx={{
                    color: value ? "#2c780c" : "text.secondary",
                    fontWeight: 500,
                    whiteSpace: "pre-line",
                    overflowWrap: "anywhere",
                }}
            >
                {value || ""}
            </Typography>

            {value ? (
                <Tooltip title="Copy to clipboard">
                    <IconButton
                        size="small"
                        onClick={() => navigator.clipboard.writeText(value)}
                    >
                        <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            ) : (
                
                <Box
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Tooltip title={question_help || ""}>
                        <InfoOutlinedIcon
                            fontSize="small"
                            sx={{ color: "error.main" }}
                        />
                    </Tooltip>
                </Box>

            )}
        </Box>
    );
}


		return (
		<TextField
			id={question_id}
			fullWidth
			variant={inline ? "standard" : "outlined"}
			value={value}
			disabled={locked > 0 || staticValue != undefined}
			sx={{
				bgcolor: locked ? "#00000011" : "none",
				color: locked === -1 ? "red" : "inherit",
			}}
			required={required}
			onChange={(e) => setLocalValue(e.target.value)}
			onBlur={(e) => {
				if (e.target.value.length > 0) setValue(e.target.value, locked === -1);
			}}
			onInput={(e: React.ChangeEvent<HTMLInputElement>) => setLocalValue(e.target.value)}
			placeholder={(hint_value.length > 0 && show_initial_response == "x") ? hint_value : ""}
			InputProps={{
				endAdornment:
				question_id.startsWith("N120.") &&
				(question_id.endsWith(".ACRES_IMPACT") ||
					question_id.endsWith(".MITIG_CALC")) ? (
					<InputAdornment position="end">ac.</InputAdornment>
				) : null,
			}}
		></TextField>
	);
};
